/**
 * Stable React keys for loading-skeleton placeholder rows.
 *
 * Skeleton rows carry no data, so there is nothing natural to key on.
 * Build the key list once (at module scope) and map over it instead of
 * keying on the ``.map`` index.
 */
export function skeletonKeys(count: number, prefix = 'skeleton'): string[] {
  return Array.from({ length: count }, (_, n) => `${prefix}-${n}`);
}
